/*eslint-disable */
import useAxios from '@/composables/useAxios'
import store from '@/store'
import useAlert from '@/view-composables/common/useAlert'
import { ref } from '@vue/composition-api'

export default function noteService(btnLoading) {
  const notes = ref([])
  const loading = ref(false)
  const fetch = params => {
    loading.value = true
    useAxios()
      .axiosGet(store.getters.routeApi('get_note'), null, params)
      .then(response => {
        if (response.status) {
          loading.value = false
          notes.value = response.data
        }
      })
  }

  const edit = (id, body, reload) => {
    btnLoading.value = true

    useAxios()
      .axiosPut(store.getters.routeApi('get_note_id').replace('_ID_', id), body)
      .then(response => {
        if (response.status) {
          btnLoading.value = false
          useAlert().successAlert('با موفقیت انجام شد')
          reload()
        } else {
          useAlert().errorAlert(response.message)
        }
      })
      .catch(() => {
        btnLoading.value = false
        useAlert().errorAlert('رویداد خطا')
      })
  }

  const add = (body, reload) => {
    btnLoading.value = true
    useAxios()
      .axiosPost(store.getters.routeApi('get_note'), body)
      .then(response => {
        if (response.status) {
          btnLoading.value = false
          useAlert().successAlert('با موفقیت انجام شد')
          reload()
        } else {
          useAlert().errorAlert(response.message)
        }
      })
      .catch(() => {
        btnLoading.value = false
        useAlert().errorAlert('رویداد خطا')
      })
  }

  const remove = (id, reload, btnDeleteLoading) => {
    btnDeleteLoading.value = true
    useAxios()
      .axiosDelete(store.getters.routeApi('get_note_id').replace('_ID_', id))
      .then(response => {
        if (response.status === true) {
          reload()
          useAlert().successAlert('با موفقیت حذف شد')
          btnDeleteLoading.value = false
        } else {
          btnDeleteLoading.value = false
          useAlert().errorAlert(response.message)
        }
      })
      .catch(() => {
        btnDeleteLoading.value = false
        useAlert().errorAlert('رویداد خطا')
      })
  }

  return {
    fetch,
    edit,
    add,
    remove,
    notes,
    loading,
  }
}
